// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vant from 'vant'
import 'vant/lib/index.css'
import router from './router'
import Mint from 'mint-ui'
import moment from 'moment'
import './utils/vueFilters' // vueFilters
import 'mint-ui/lib/style.css'
import 'mint-ui/lib/swipe/style.css'
import 'mint-ui/lib/swipe-item/style.css'
import 'mint-ui/lib/message-box/style.css'
import './assets/styles/safeStudyPA.css'
import '../static/filter/formatDate'
import Vconsole from 'vconsole'
import axios from 'axios'
import store from './store'

// import VueDPlayer from 'vue-dplayer'
// import 'vue-dplayer/dist/vue-dplayer.css'
// 移动端调试工具
// const vConsole = new Vconsole()
// Vue.use(vConsole)
Vue.use(require('vue-wechat-title'))
// Vue.use(VueDPlayer)
// Object.keys(formatDate).forEach(key => {
//   Vue.filter(key, formatDate[key])
// })
Vue.use(Mint)
Vue.use(Vant)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
// 注册全局moment
Vue.prototype.$moment = moment
Vue.prototype.FormatDate = function (value, isLongTime) {
  if (isLongTime) {
    // return moment(value).format('YYYYMM')
    return moment(value).format('YYYY')
  }
  return moment(value).format('YYYY-MM-DD HH:mm')
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
// 解决适配
// var ele = document.getElementsByTagName('html')[0]
// var size = document.body.clientWidth / 375 * 100
// ele.style.fontSize = size + 'px'
document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.50 + 'px'

// 解决微信返回按钮到上一页页面不刷新的问题
window.onpageshow = function (event) {
  // event.persisted 判断浏览器是否有缓存, 有为true, 没有为false
  if (event.persisted) {
    window.location.reload()
  }
}



// WEBPACK FOOTER //
// ./src/main.js